var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"todo-imprimbook"}},[_c('h2',[_vm._v("LOREM IPSUM")]),_c('p',[_vm._v("Puzzle, etc. a renvoyer sur le form groupe-santerre")])])}]

export { render, staticRenderFns }